import styled from "styled-components";

export const AuthFormWrapper = styled.div`
    width: 100%;
    max-width: 400px;
    padding: 24px;
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

    /* Form layout */
    .ant-form {
        margin-top: 8px;
    }

    /* Label */
    .ant-form-item-label > label {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.88);
    }

    /* Input fields */
    .ant-input,
    .ant-input-password {
        border-radius: 6px;
        font-size: 15px;
    }

    /* Hover state */
    .ant-input:hover,
    .ant-input-affix-wrapper:hover {
        border-color: #2f9e44;
    }

    /* Focus state */
    .ant-input:focus,
    .ant-input-focused,
    .ant-input-affix-wrapper-focused {
        border-color: #33cc6b !important;
        box-shadow: 0 0 0 2px rgba(47, 158, 68, 0.2) !important;
    }

    /* Center button safely */
    .ant-form-item:last-child .ant-form-item-control-input-content {
        display: flex;
        justify-content: center;
    }

    /* Button styling */
    .ant-btn-primary {
        background-color: #2f9e44;
        border-color: #2f9e44;
        font-weight: bold;
        height: 45px;
        border-radius: 6px;
        width: 100%;
    }

    .ant-btn-primary:hover,
    .ant-btn-primary:focus {
        background-color: #2b8a3e;
        border-color: #2b8a3e;
    }
`;
